import axios from "axios";
import {LanguageObject} from "@/i18n";

interface Deployment {
    name: LanguageObject;
    key: string;
    state: 'active';
}

const getDeploymentInfo = async () => {
    const resp = await axios.get<Deployment>('/deployment/info.php');
    return resp.data;
};

export default {
    getDeploymentInfo
}

export {
    Deployment
}